module.exports = __webpack_public_path__ + "img/money.ba167c8a.svg";